var $0bf46fdcdd7cb5f6$exports = {};
$0bf46fdcdd7cb5f6$exports = {
  "removeButtonLabel": "Kald\u0131r",
  "removeDescription": "Etiketi kald\u0131rmak i\xE7in Sil tu\u015Funa bas\u0131n."
};
export { $0bf46fdcdd7cb5f6$exports as default };